import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RequestTrackerService {
  public isLoading$ = new BehaviorSubject<boolean>(false);
  private activeRequests = 0;
  private showTimer: any;
  private hideTimer: any;
  private visibleSince = 0;

  private readonly showDelayMs = 120;
  private readonly minVisibleMs = 250;

  show() {
    this.activeRequests += 1;

    if (this.activeRequests !== 1) {
      return;
    }

    clearTimeout(this.hideTimer);
    clearTimeout(this.showTimer);

    this.showTimer = setTimeout(() => {
      if (this.activeRequests > 0 && !this.isLoading$.value) {
        this.visibleSince = Date.now();
        this.isLoading$.next(true);
      }
    }, this.showDelayMs);
  }

  hide() {
    if (this.activeRequests === 0) {
      return;
    }

    this.activeRequests -= 1;

    if (this.activeRequests > 0) {
      return;
    }

    clearTimeout(this.showTimer);

    const elapsed = Date.now() - this.visibleSince;
    const remainingVisibleMs = this.isLoading$.value
      ? Math.max(0, this.minVisibleMs - elapsed)
      : 0;

    clearTimeout(this.hideTimer);

    this.hideTimer = setTimeout(() => {
      if (this.activeRequests === 0 && this.isLoading$.value) {
        this.isLoading$.next(false);
      }
    }, remainingVisibleMs);
  }
}
